var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDash5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4965 36V52.5035H50.5008V19.3752L42.6716 11.4966H16.4965V15.2704",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4965 36V52.5035H50.5008V19.3752L42.6716 11.4966H16.4965V15.2704",
    stroke: "#9A9FB0",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6716 11.4966V19.3587L50.5009 19.3752",
    stroke: "#9A9FB0",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9473 23.9268H46.582",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9473 27.8994H46.582",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9473 31.8718H42.6715",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7163 14.8979C14.0752 14.8979 9.49915 19.4414 9.49915 25.0524H19.7163V14.8979Z",
    fill: "white",
    stroke: "url(#paint0_linear)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7171 20.5503L22.6617 27.8993H12.4529C12.4529 33.5103 17.029 38.062 22.67 38.062C28.311 38.062 32.8788 33.5103 32.8788 27.8993C32.8788 25.011 31.6641 22.3958 29.7171 20.5503Z",
    fill: "white",
    stroke: "url(#paint1_linear)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6617 17.7366V27.8C22.6617 27.8331 22.7033 27.8497 22.7283 27.8249L29.7172 20.5421C27.8868 18.8042 25.3991 17.7366 22.6617 17.7366Z",
    fill: "white",
    stroke: "url(#paint2_linear)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9763 49.0939C24.9504 49.0939 25.7401 48.3084 25.7401 47.3394C25.7401 46.3705 24.9504 45.585 23.9763 45.585C23.0021 45.585 22.2124 46.3705 22.2124 47.3394C22.2124 48.3084 23.0021 49.0939 23.9763 49.0939Z",
    stroke: "url(#paint3_linear)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.366 42.7792C31.3402 42.7792 32.1299 41.9937 32.1299 41.0247C32.1299 40.0558 31.3402 39.2703 30.366 39.2703C29.3919 39.2703 28.6022 40.0558 28.6022 41.0247C28.6022 41.9937 29.3919 42.7792 30.366 42.7792Z",
    stroke: "url(#paint4_linear)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9473 49.0939C37.9215 49.0939 38.7112 48.3084 38.7112 47.3394C38.7112 46.3705 37.9215 45.585 36.9473 45.585C35.9732 45.585 35.1835 46.3705 35.1835 47.3394C35.1835 48.3084 35.9732 49.0939 36.9473 49.0939Z",
    stroke: "url(#paint5_linear)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1259 41.1242C46.1001 41.1242 46.8898 40.3387 46.8898 39.3697C46.8898 38.4007 46.1001 37.6152 45.1259 37.6152C44.1518 37.6152 43.3621 38.4007 43.3621 39.3697C43.3621 40.3387 44.1518 41.1242 45.1259 41.1242Z",
    stroke: "url(#paint6_linear)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2325 46.0978L29.118 42.2578",
    stroke: "url(#paint7_linear)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2036 46.1145L43.8613 40.5945",
    stroke: "url(#paint8_linear)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.639 42.2415L35.6743 46.1228",
    stroke: "url(#paint9_linear)",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 10.4007,
    y1: 21.0591,
    x2: 19.822,
    y2: 17.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 14.2552,
    y1: 31.1754,
    x2: 32.3887,
    y2: 23.6915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 23.2843,
    y1: 23.8648,
    x2: 30.1928,
    y2: 22.1573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 22.5237,
    y1: 47.714,
    x2: 25.7772,
    y2: 46.5566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 28.9134,
    y1: 41.3993,
    x2: 32.167,
    y2: 40.2419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 35.4947,
    y1: 47.714,
    x2: 38.7483,
    y2: 46.5566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 43.6733,
    y1: 39.7443,
    x2: 46.9269,
    y2: 38.5869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 25.5754,
    y1: 44.5877,
    x2: 29.1537,
    y2: 43.3066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 38.7028,
    y1: 43.9437,
    x2: 43.8978,
    y2: 42.0597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 31.9951,
    y1: 44.5964,
    x2: 35.688,
    y2: 43.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4164DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587CF4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(9 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash5);
export default __webpack_public_path__ + "static/media/dash5.6e5df9f3d969947b49d12c5e4d6a6e20.svg";
export { ForwardRef as ReactComponent };